import React from 'react';

const CustomHorizontalTimeline = () => {
  return (
    <section {...({ class: 'timeline-wrapper' } as any)}>
      <div {...({ class: 'middle-line' } as any)}></div>

      <div {...({ class: 'box box-top' } as any)}>
        <div {...({ class: 'box-content' } as any)}>
          <p {...({ class: 'box-year' } as any)}>2022</p>
          <p {...({ class: 'box-paragraf' } as any)}>
            Rapidly growth in <strong>Semiconductors</strong> domain.
          </p>
        </div>
        <div></div>
      </div>

      <div {...({ class: 'box box-bottom' } as any)}>
        <div {...({ class: 'box-content' } as any)}>
          <p {...({ class: 'box-year year-bottom' } as any)}>2019</p>
          <p {...({ class: 'box-paragraf-bottom' } as any)}>
            Added <strong>Ceramic THT Capacitors</strong> to portfolio.
          </p>
        </div>
        <div></div>
      </div>

      <div {...({ class: 'box box-top' } as any)}>
        <div {...({ class: 'box-content' } as any)}>
          <p {...({ class: 'box-year' } as any)}> 2016</p>
          <p {...({ class: 'box-paragraf' } as any)}>
            Developed new products – <strong>THT Resistors.</strong>
          </p>
        </div>
        <div></div>
      </div>

      <div {...({ class: 'box box-bottom' } as any)}>
        <div {...({ class: 'box-content' } as any)}>
          <p {...({ class: 'box-year year-bottom' } as any)}>2009</p>
          <p {...({ class: 'box-paragraf-bottom' } as any)}>
            Expanded offer with <strong>Film Capacitors.</strong>
          </p>
        </div>
        <div></div>
      </div>

      <div {...({ class: 'box box-top' } as any)}>
        <div {...({ class: 'box-content' } as any)}>
          <p {...({ class: 'box-year' } as any)}>2005</p>
          <p {...({ class: 'box-paragraf' } as any)}>
            Akyga started production and distribution of{' '}
            <strong>Primary and Rechargeable Batteries.</strong>
          </p>
        </div>
        <div></div>
      </div>
    </section>
  );
};

export default CustomHorizontalTimeline;
